var _path, _path2, _path3, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCubeleft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2170_1363)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.603 73.9401C172.2 73.4883 171.669 73.1695 171.08 73.0261L108.193 58.3698C107.718 58.2589 107.222 58.2654 106.75 58.3888C106.277 58.5122 105.842 58.7489 105.481 59.0782L57.7957 102.618C57.3537 103.03 57.0465 103.567 56.9139 104.157L122.711 119.495L172.603 73.9401Z",
    fill: "url(#paint0_linear_2170_1363)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.711 119.495L140.956 189.328C141.428 189.205 141.863 188.968 142.224 188.639L189.91 145.1C190.314 144.73 190.61 144.257 190.765 143.732C190.921 143.207 190.93 142.649 190.791 142.119L173.309 75.1937C173.181 74.7238 172.937 74.2944 172.603 73.9401L122.711 119.495Z",
    fill: "url(#paint1_linear_2170_1363)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9139 104.157C56.7972 104.63 56.7976 105.124 56.9147 105.598L74.3965 172.523C74.5348 173.053 74.8153 173.535 75.2077 173.917C75.6001 174.3 76.0895 174.568 76.623 174.692L139.51 189.348C139.986 189.459 140.483 189.452 140.956 189.328L122.711 119.495L56.9139 104.157Z",
    fill: "url(#paint2_linear_2170_1363)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -27.2964,
    y: -25.2461,
    width: 275.031,
    height: 193.305
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(25.38px)",
      clipPath: "url(#bgblur_1_2170_1363_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2170_1363)",
    "data-figma-bg-blur-radius": 50.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.984 48.9774C196.379 48.2996 195.583 47.8215 194.7 47.6063L100.371 25.6219C99.6579 25.4554 98.9147 25.4652 98.206 25.6503C97.4972 25.8355 96.8442 26.1904 96.3034 26.6845L24.7763 91.9929C24.1134 92.6119 23.6525 93.4163 23.4537 94.3012L122.148 117.309L196.984 48.9774Z",
    fill: "url(#paint3_linear_2170_1363)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5264 26.8777C99.0358 26.7447 99.57 26.7382 100.083 26.8578L100.084 26.8576L194.399 48.8389L194.4 48.8387C194.612 48.8905 194.817 48.9657 195.013 49.0582L121.786 115.921L25.2161 93.4094C25.3413 93.2337 25.4822 93.0685 25.6414 92.9198L97.1593 27.6214C97.5479 27.2664 98.0171 27.0108 98.5264 26.8777Z",
    stroke: "url(#paint4_linear_2170_1363)",
    strokeOpacity: 0.1,
    strokeWidth: 2.5375
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 71.3976,
    y: -1.77295,
    width: 203.761,
    height: 274.583
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(25.38px)",
      clipPath: "url(#bgblur_2_2170_1363_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2170_1363)",
    "data-figma-bg-blur-radius": 50.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.148 117.308L149.51 222.06C150.219 221.875 150.872 221.52 151.413 221.026L222.94 155.718C223.547 155.164 223.99 154.454 224.223 153.666C224.456 152.878 224.47 152.042 224.262 151.247L198.039 50.8599C197.847 50.155 197.485 49.5084 196.983 48.977L122.148 117.308Z",
    fill: "url(#paint5_linear_2170_1363)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.758 51.006L196.815 51.193L223.034 151.567L223.082 151.783C223.179 152.289 223.153 152.811 223.006 153.307C222.839 153.873 222.52 154.383 222.084 154.781L150.558 220.09C150.492 220.15 150.421 220.205 150.351 220.26L123.568 117.728L196.728 50.9272C196.737 50.9536 196.749 50.9793 196.758 51.006Z",
    stroke: "url(#paint6_linear_2170_1363)",
    strokeOpacity: 0.1,
    strokeWidth: 2.5375
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -27.4281,
    y: 43.5508,
    width: 227.688,
    height: 229.406
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(25.38px)",
      clipPath: "url(#bgblur_3_2170_1363_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2170_1363)",
    "data-figma-bg-blur-radius": 50.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.453 94.301C23.2779 95.0115 23.2782 95.7539 23.4539 96.4642L49.6763 196.851C49.8838 197.646 50.3046 198.369 50.8932 198.943C51.4817 199.516 52.2158 199.918 53.016 200.105L147.345 222.089C148.059 222.255 148.802 222.245 149.51 222.06L122.148 117.308L23.453 94.301Z",
    fill: "url(#paint7_linear_2170_1363)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.114 118.37L147.896 220.901C147.808 220.888 147.72 220.874 147.633 220.853L147.632 220.853L53.3042 198.869C52.7292 198.735 52.2019 198.446 51.779 198.034C51.356 197.622 51.053 197.102 50.9038 196.531L24.6854 96.1593C24.6624 96.0662 24.6447 95.9722 24.6301 95.878L121.114 118.37Z",
    stroke: "url(#paint8_linear_2170_1363)",
    strokeOpacity: 0.1,
    strokeWidth: 2.5375
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2170_1363",
    x: -27.2964,
    y: -25.2461,
    width: 275.031,
    height: 193.305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.45833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1363"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_2170_1363_clip_path",
    transform: "translate(27.2964 25.2461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.984 48.9774C196.379 48.2996 195.583 47.8215 194.7 47.6063L100.371 25.6219C99.6579 25.4554 98.9147 25.4652 98.206 25.6503C97.4972 25.8355 96.8442 26.1904 96.3034 26.6845L24.7763 91.9929C24.1134 92.6119 23.6525 93.4163 23.4537 94.3012L122.148 117.309L196.984 48.9774Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2170_1363",
    x: 71.3976,
    y: -1.77295,
    width: 203.761,
    height: 274.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.45833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1363"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_2170_1363_clip_path",
    transform: "translate(-71.3976 1.77295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.148 117.308L149.51 222.06C150.219 221.875 150.872 221.52 151.413 221.026L222.94 155.718C223.547 155.164 223.99 154.454 224.223 153.666C224.456 152.878 224.47 152.042 224.262 151.247L198.039 50.8599C197.847 50.155 197.485 49.5084 196.983 48.977L122.148 117.308Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2170_1363",
    x: -27.4281,
    y: 43.5508,
    width: 227.688,
    height: 229.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.45833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1363"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_2170_1363_clip_path",
    transform: "translate(27.4281 -43.5508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.453 94.301C23.2779 95.0115 23.2782 95.7539 23.4539 96.4642L49.6763 196.851C49.8838 197.646 50.3046 198.369 50.8932 198.943C51.4817 199.516 52.2158 199.918 53.016 200.105L147.345 222.089C148.059 222.255 148.802 222.245 149.51 222.06L122.148 117.308L23.453 94.301Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2170_1363",
    x1: 48.554,
    y1: 73.5903,
    x2: 195.616,
    y2: 68.6601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2170_1363",
    x1: 48.554,
    y1: 73.5903,
    x2: 195.616,
    y2: 68.6601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2170_1363",
    x1: 48.554,
    y1: 73.5903,
    x2: 195.616,
    y2: 68.6601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2170_1363",
    x1: 11.4413,
    y1: 48.3145,
    x2: 210.382,
    y2: 87.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2170_1363",
    x1: 17.9524,
    y1: 51.0642,
    x2: 186.059,
    y2: 7.15249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2170_1363",
    x1: 110.219,
    y1: 71.6411,
    x2: 221.474,
    y2: 59.4435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2170_1363",
    x1: 114.733,
    y1: 77.7658,
    x2: 199.297,
    y2: 55.6762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2170_1363",
    x1: 22.9249,
    y1: 94.439,
    x2: 134.18,
    y2: 82.2408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2170_1363",
    x1: 27.4389,
    y1: 100.564,
    x2: 112.004,
    y2: 78.4743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2170_1363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 203,
    height: 203,
    fill: "white",
    transform: "translate(0 51.3047) rotate(-14.6393)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeleft);
export default __webpack_public_path__ + "static/media/cubeleft.bdb68ee12d826f21e224491f8b81e286.svg";
export { ForwardRef as ReactComponent };